export default {
  title: "Phone numbers",

  noItems: {
    title: "No phone numbers",
    text: "Click to add a phone number"
  },

  input: {
    title: "{{action}} phone number",
    type: {
      label: "Type",
    },
    phoneNumber: {
      label: "Phone number",
    },
  },
}
